import React from 'react';
import { Box } from '@mui/material';
import {
  SpotPriceLevel,
  SpotPricePeriod,
} from '../../../../../core/src/shared/enums';
import { colors } from '../../../theme/palette';

export const ColPriceLevel = ({
  periodIndex,
  pricePeriod = SpotPricePeriod['60M'],
  value,
  tooltip,
}: {
  periodIndex: number;
  pricePeriod?: SpotPricePeriod;
  value: SpotPriceLevel;
  tooltip?: string;
}) => {
  let bgcolor = 'grey.200';
  if (value === SpotPriceLevel.Hi) {
    bgcolor = 'error.main';
  } else if (value === SpotPriceLevel.Mid) {
    bgcolor = colors.brightOrange;
  } else {
    bgcolor = 'success.main';
  }

  return (
    <Box
      sx={{
        gridColumn: pricePeriod === '15M' ? 'span 1' : 'span 4',
        py: 0.5,
      }}
      className={`spot-summary-col-${pricePeriod}-${periodIndex}`}
      data-tooltip={tooltip}
    >
      <Box
        sx={{
          width: 'auto',
          height: { xs: 18, sm: 26 },
          bgcolor,
        }}
      />
    </Box>
  );
};
